<template>
  <nav class="navbar navbar-expand-lg navbar-dark bg-primary">
    <router-link class="navbar-brand" to="/">{{ storeName }}</router-link>
    <button class="navbar-toggler" type="button" data-toggle="collapse" data-target="#navbarSupportedContent"
            aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation">
      <span class="navbar-toggler-icon"></span>
    </button>

    <div class="collapse navbar-collapse" id="navbarSupportedContent">
      <ul class="navbar-nav mr-auto">
        <li class="nav-item">
          <router-link class="nav-link" :to="{name: 'sale'}"><i class="fas fa-plus mr-1"></i> Sale</router-link>
        </li>
        <li class="nav-item">
          <router-link class="nav-link" :to="{name: 'fulfill'}"><i class="fas fa-check mr-1"></i> Fulfill</router-link>
        </li>
        <li class="nav-item">
          <div class="custom-control custom-switch check-deliver-orders-wrapper">
            <input v-model="markItemsAsDelivered" type="checkbox" class="custom-control-input" id="check-deliver-orders">
            <label class="custom-control-label nav-link" for="check-deliver-orders">Mark items as Delivered</label>
          </div>
        </li>
      </ul>
      <ul class="navbar-nav">
        <li class="nav-item">
          <router-link class="nav-link" :to="{name: 'stores'}"><i class="fas fa-store-alt mr-1"></i> Stores</router-link>
        </li>
        <li class="nav-item dropdown">
          <a class="nav-link dropdown-toggle" href="#" id="navbar-dropdown-user" role="button" data-toggle="dropdown"
             aria-haspopup="true" aria-expanded="false">
            <i class="fa fa-user mr-1"></i> {{ $store.state.user.name }}
          </a>
          <div class="dropdown-menu" aria-labelledby="navbar-dropdown-user">
            <!--<a class="dropdown-item" href="#">Action</a>
            <a class="dropdown-item" href="#">Another action</a>
            <div class="dropdown-divider"></div>-->
            <a class="dropdown-item" href="#" @click.prevent="processLogout">Logout</a>
          </div>
        </li>
      </ul>
    </div>
  </nav>
</template>

<script>
export default {
  name: 'Navigation',
  data () {
    return {
      markItemsAsDelivered: localStorage.getItem('mark-items-as-delivered') === 'true'
    }
  },
  computed: {
    storeName () {
      return this.$store.state.store ? this.$store.state.store.name : process.env.APP_NAME
    }
  },
  watch: {
    markItemsAsDelivered: function () {
      localStorage.setItem('mark-items-as-delivered', this.markItemsAsDelivered)
    }
  },
  methods: {
    processLogout () {
      this.$store.dispatch('processLogout')
      this.$toast.success('You have successfully logged out!')
      // this.$router.push('login')
      document.location.href = '/login'
    }
  }
}
</script>

<style scoped>
.check-deliver-orders-wrapper {
  margin-left: 1rem;
}

.check-deliver-orders-wrapper .custom-control-label {
  padding-left: 0 !important;
}

.check-deliver-orders-wrapper .custom-control-label::before,
.check-deliver-orders-wrapper .custom-control-label::after {
  margin-top: 8px;
}

.check-deliver-orders-wrapper .custom-control-label::before {
  border-color: #adb5bd !important;
}
</style>



// WEBPACK FOOTER //
// src/components/partials/Navigation.vue